<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="locationGroupsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeLocationGroupsField] ? 'Exclude' : 'Include')} Location Groups`"
      :options="locationGroups.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one location group'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeLocationGroupsField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/tip/TipShareRule'

export default {
  name: 'LocationGroupsConditionForm',
  configuration: ['locationGroups'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    locationGroupsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.LOCATION_GROUPS
    },
    excludeLocationGroupsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_LOCATION_GROUPS
    }
  }
}

</script>
